import React, { useContext } from 'react';
import { Formik } from 'formik';
import Checkbox from '@atoms/Checkbox';
import { ConfigFilterContext } from '../../../context/searchContext';

const PastItemFilter = () => {
    const { toggleToIncludePastDates, includePastEvents } = useContext(ConfigFilterContext);

    const handleChange = newValue => {
        toggleToIncludePastDates(newValue);
    };

    return (
        <Formik
            initialValues={{
                show_past_items: includePastEvents,
            }}
        >
            {({ values }) => <Checkbox name="show_past_items" label="Include Past Dates" onChange={handleChange} />}
        </Formik>
    );
};

export default PastItemFilter;
